import type { Cart, ProductInterface } from '@vue-storefront/magento-types'

export const isGiftcardHolder = (product: ProductInterface) =>
  /^MJ071\d{2}-1700-OS$/.test(product.sku!) ||
  /giftcardholder|geschenkkartenhalter|gift card holder/i.test(product.name!)

export const getGiftcardHolders = (cartItems: Cart['items']) =>
  cartItems?.filter((cartItem) => isGiftcardHolder(cartItem?.product!)) ?? []
